module.exports = __webpack_public_path__ + "img/img.ea3bf081.png";